import { render, staticRenderFns } from "./PlanningModule.vue?vue&type=template&id=0be9b64c&scoped=true"
import script from "./PlanningModule.vue?vue&type=script&lang=js"
export * from "./PlanningModule.vue?vue&type=script&lang=js"
import style0 from "./PlanningModule.vue?vue&type=style&index=0&id=0be9b64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9b64c",
  null
  
)

export default component.exports